const mobileNavigationBody = document.querySelector('#mobile-navigation-body');
const mobileNavigation = document.querySelector('#mobile-navigation');
const mobileNavToggleButton = document.querySelector('#mobile-nav-toggle');

let isMobileMenuExpanded = false;
let currentLevel = 0;
let navigationHistory = [];
let isAnimating = false;

function getCurrentMenuLevel(element) {
    return element.closest('.mobile-menu-level, .mobile-submenu');
}

function getCurrentLevelMenuItems(levelContainer) {
    if (!levelContainer) return [];
    const directItems = Array.from(levelContainer.children)
        .filter(li => li.classList.contains('mobile-menu-item'))
        .map(li => li.querySelector('button, a'))
        .filter(item => item);
        
    return directItems;
}

function resetToRootLevel() {
    navigationHistory = [];
    navigateBack(null);
}

function toggleMobileMenu(e) {
    if (e) {
        e.stopPropagation();
    }
    
    if (!mobileNavigation || !mobileNavToggleButton) {
        console.warn('Mobile navigation elements not found');
        return;
    }
    
    if (isAnimating) {
        return;
    }
    
    if (isMobileMenuExpanded) {
        closeMobileMenu();
    } else {
        openMobileMenu();
    }
}

function openMobileMenu() {
    if (!mobileNavigation || !mobileNavToggleButton) return;
    
    isAnimating = true;
    isMobileMenuExpanded = true;
    mobileNavToggleButton.setAttribute('aria-pressed', 'true');
    mobileNavigation.classList.add('open');
    document.body.classList.add('no-scroll');
    
    if (window.closeAllSubmenus) {
        window.closeAllSubmenus();
    }
    if (window.isSearchModalOpen && window.hideSearchModal) {
        window.hideSearchModal();
    }
    
    navigateToCurrentPageSubmenu();
    announceToScreenReader('Mobilmenu åbner');
    
    setTimeout(() => {
        const firstFocusable = mobileNavigation.querySelector('button, a, [tabindex]:not([tabindex="-1"])');
        if (firstFocusable) {
            firstFocusable.focus();
        }
        isAnimating = false;
    }, 100);
}

function closeMobileMenu() {
    if (!mobileNavigation || !mobileNavToggleButton) return;
    
    isAnimating = true;
    isMobileMenuExpanded = false;
    mobileNavToggleButton.setAttribute('aria-pressed', 'false');
    document.body.classList.remove('no-scroll');
    
    resetToRootLevel();
    announceToScreenReader('Mobilmenu lukker');

    mobileNavigation.classList.add('closing');
    
    setTimeout(() => {
        mobileNavigation.classList.remove('open', 'closing');
        isAnimating = false;
    }, 800);
    
    mobileNavToggleButton.focus();
}

function navigateToSubmenu(targetSubmenu, triggerButton) {
    navigationHistory.push({
        submenu: targetSubmenu,
        button: triggerButton
    });
    
    const depth = parseInt(targetSubmenu.getAttribute('data-depth')) || 1;
    
    const currentLevelElement = triggerButton.closest('.mobile-menu-level, .mobile-submenu');
    if (currentLevelElement) {
        currentLevelElement.querySelectorAll('.mobile-menu-item').forEach(item => {
            item.classList.remove('submenu-active');
        });
        
        const parentMenuItem = triggerButton.closest('.mobile-menu-item');
        if (parentMenuItem) {
            parentMenuItem.classList.add('submenu-active');
        }
    }
    
    const backButton = targetSubmenu.querySelector('.mobile-back-button');
    if (backButton) {
        backButton.focus();
    }

    mobileNavigation.scrollTo(0, 0);
    
    setTimeout(() => {
        triggerButton.setAttribute('aria-expanded', 'true');
        
        const transformValue = -(depth * 100);
        mobileNavigationBody.style.transform = `translateX(${transformValue}%)`;
        mobileNavigationBody.style.transition = 'transform 300ms ease';
        
        currentLevel = depth;
        
        const staticMenuItems = mobileNavigationBody.querySelector('.mobile-menu-static');
        if (staticMenuItems && depth > 0) {
            staticMenuItems.classList.add('hidden');
        }
        
        announceToScreenReader(`Navigeret til ${triggerButton.textContent.trim()}`);
    }, 10);
}

function navigateBack(targetSubmenu) {
    const lastNavState = navigationHistory.pop();
    
    if (lastNavState && lastNavState.submenu) {
        const triggerButton = mobileNavigationBody.querySelector(`[data-target="${lastNavState.submenu.id}"]`);
        if (triggerButton) {
            triggerButton.setAttribute('aria-expanded', 'false');
            
            const parentMenuItem = triggerButton.closest('.mobile-menu-item');
            if (parentMenuItem) {
                parentMenuItem.classList.remove('submenu-active');
            }
        }
    }
    
    if (lastNavState && lastNavState.button) {
        lastNavState.button.focus();
    } else if (navigationHistory.length === 0) {
        const firstMenuItem = mobileNavigationBody.querySelector('#mobile-menu-root button, #mobile-menu-root a, [tabindex]:not([tabindex="-1"])');
        if (firstMenuItem) {
            firstMenuItem.focus();
        }
    }
    
    setTimeout(() => {
        const staticMenuItems = mobileNavigationBody.querySelector('.mobile-menu-static');
        
        if (navigationHistory.length === 0) {
            mobileNavigationBody.style.transform = 'translateX(0%)';
            currentLevel = 0;
            
            const allButtons = mobileNavigationBody.querySelectorAll('.mobile-menu-button[aria-expanded="true"]');
            allButtons.forEach(button => {
                button.setAttribute('aria-expanded', 'false');
            });
            
            mobileNavigationBody.querySelectorAll('.mobile-menu-item').forEach(item => {
                item.classList.remove('submenu-active');
            });
            
            if (staticMenuItems) {
                staticMenuItems.classList.remove('hidden');
            }
            
            if (!mobileNavigation.classList.contains('closing')) {
                announceToScreenReader('Tilbage til hovedmenu');
            }
        } else {
            const currentSubmenu = navigationHistory[navigationHistory.length - 1].submenu;
            const newDepth = parseInt(currentSubmenu.getAttribute('data-depth')) || 1;
            
            const transformValue = -(newDepth * 100);
            mobileNavigationBody.style.transform = `translateX(${transformValue}%)`;
            currentLevel = newDepth;
            
            if (staticMenuItems && newDepth > 0) {
                staticMenuItems.classList.add('hidden');
            }
            
            const parentName = targetSubmenu?.querySelector('.mobile-submenu-title')?.textContent || 'forrige niveau';
            announceToScreenReader(`Tilbage til ${parentName}`);
        }
    }, 10);
}

function navigateToCurrentPageSubmenu() {
    if (!mobileNavigation) return;
    
    const currentPageElement = mobileNavigation.querySelector('.current-page');
    if (!currentPageElement) return;
    
    const targetSubmenu = currentPageElement.closest('.mobile-submenu');
    if (!targetSubmenu) return;
    
    const navigationPath = [];
    let currentSubmenu = targetSubmenu;
    
    while (currentSubmenu && currentSubmenu.id !== 'mobile-menu-root') {
        const triggerButton = mobileNavigationBody.querySelector(`[data-target="${currentSubmenu.id}"]`);
        if (triggerButton) {
            navigationPath.unshift({ submenu: currentSubmenu, button: triggerButton });
        }
        currentSubmenu = currentSubmenu.parentElement?.closest('.mobile-submenu');
    }
    
    if (navigationPath.length > 0) {
        jumpToSubmenuDirectly(navigationPath);
    }
}

function jumpToSubmenuDirectly(navigationPath) {
    const targetPath = navigationPath[navigationPath.length - 1];
    const { submenu: targetSubmenu, button: targetButton } = targetPath;
    
    navigationHistory = navigationPath.map(({ submenu, button }) => ({
        submenu: submenu,
        button: button
    }));
    
    navigationPath.forEach(({ button }) => {
        button.setAttribute('aria-expanded', 'true');
        const parentMenuItem = button.closest('.mobile-menu-item');
        if (parentMenuItem) {
            parentMenuItem.classList.add('submenu-active');
        }
    });
    
    const targetDepth = parseInt(targetSubmenu.getAttribute('data-depth')) || 1;
    const transformValue = -(targetDepth * 100);
    
    mobileNavigationBody.style.transition = 'none'; 
    mobileNavigationBody.style.transform = `translateX(${transformValue}%)`;
    
    currentLevel = targetDepth;
    
    const staticMenuItems = mobileNavigationBody.querySelector('.mobile-menu-static');
    if (staticMenuItems && targetDepth > 0) {
        staticMenuItems.classList.add('hidden');
    }
    
    setTimeout(() => {
        mobileNavigationBody.style.transition = 'transform 300ms ease';
    }, 50);
}

function navigateMenuItems(items, currentIndex, direction) {
    let nextIndex;
    switch (direction) {
        case 'next':
            nextIndex = (currentIndex + 1) % items.length;
            break;
        case 'prev':
            nextIndex = currentIndex === 0 ? items.length - 1 : currentIndex - 1;
            break;
        case 'first':
            nextIndex = 0;
            break;
        case 'last':
            nextIndex = items.length - 1;
            break;
    }
    if (items[nextIndex]) {
        items[nextIndex].focus();
    }
}

function handleKeyNavigation(e, element, menuItems) {
    const currentIndex = Array.from(menuItems).indexOf(element);
    
    switch (e.key) {
        case 'Enter':
        case ' ':
            e.preventDefault();
            element.click();
            break;
            
        case 'ArrowDown':
            e.preventDefault();
            navigateMenuItems(menuItems, currentIndex, 'next');
            break;
            
        case 'ArrowUp':
            e.preventDefault();
            navigateMenuItems(menuItems, currentIndex, 'prev');
            break;
            
        case 'ArrowRight':
            e.preventDefault();
            if (element.classList.contains('mobile-menu-button')) {
                element.click();
            }
            break;
            
        case 'ArrowLeft':
        case 'Escape':
            e.preventDefault();
            if (navigationHistory.length > 0) {
                const lastNavState = navigationHistory[navigationHistory.length - 1];
                if (lastNavState.submenu) {
                    navigateBack(lastNavState.submenu);
                }
            } else if (e.key === 'Escape') {
                closeMobileMenu();
            }
            break;
            
        case 'Home':
            e.preventDefault();
            navigateMenuItems(menuItems, currentIndex, 'first');
            break;
            
        case 'End':
            e.preventDefault();
            navigateMenuItems(menuItems, currentIndex, 'last');
            break;
    }
}

function initializeDrillDown() {
    const menuButtons = mobileNavigationBody.querySelectorAll('.mobile-menu-button');
    const backButtons = mobileNavigationBody.querySelectorAll('.mobile-back-button');

    menuButtons.forEach(button => {
        button.addEventListener('click', (e) => {
            e.preventDefault();
            const targetId = button.getAttribute('data-target');
            const targetSubmenu = document.getElementById(targetId);
            
            if (targetSubmenu) {
                navigateToSubmenu(targetSubmenu, button);
            }
        });

        button.addEventListener('keydown', (e) => {
            const currentLevel = getCurrentMenuLevel(button);
            const menuItems = getCurrentLevelMenuItems(currentLevel);
            handleKeyNavigation(e, button, menuItems);
        });
    });

    backButtons.forEach(button => {
        button.addEventListener('click', (e) => {
            e.preventDefault();
            const targetId = button.getAttribute('data-target');
            
            if (targetId === 'mobile-menu-root') {
                navigationHistory = [];
                navigateBack(null);
            } else {
                const targetSubmenu = document.getElementById(targetId);
                if (targetSubmenu) {
                    navigateBack(targetSubmenu);
                }
            }
        });

        button.addEventListener('keydown', (e) => {
            const currentLevel = getCurrentMenuLevel(button);
            const menuItems = getCurrentLevelMenuItems(currentLevel);
            handleKeyNavigation(e, button, menuItems);
        });
    });
    
    const menuLinks = mobileNavigationBody.querySelectorAll('.mobile-menu-link');
    menuLinks.forEach(link => {
        link.addEventListener('keydown', (e) => {
            const currentLevel = getCurrentMenuLevel(link);
            const menuItems = getCurrentLevelMenuItems(currentLevel);
            handleKeyNavigation(e, link, menuItems);
        });
    });
    
    const staticMenuItems = mobileNavigationBody.querySelectorAll('.mobile-menu-static-list .mobile-menu-link');
    staticMenuItems.forEach(link => {
        link.addEventListener('keydown', (e) => {
            handleKeyNavigation(e, link, staticMenuItems);
        });
    });
    
    document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && isMobileMenuExpanded) {
            e.preventDefault();
            if (navigationHistory.length > 0) {
                const lastNavState = navigationHistory[navigationHistory.length - 1];
                if (lastNavState.submenu) {
                    navigateBack(lastNavState.submenu);
                }
            } else {
                closeMobileMenu();
            }
        }
    });
}

function initializeToggleButton() {
    if (mobileNavToggleButton) {
        mobileNavToggleButton.addEventListener('click', toggleMobileMenu);
        mobileNavToggleButton.addEventListener('keydown', (e) => {
            if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                e.stopPropagation();
                toggleMobileMenu(e);
            }
        });
    }
}

function initializeMobileNavigation() {
    if (!mobileNavigationBody) return;

    initializeDrillDown();
}

function announceToScreenReader(message) {
    const announcement = document.createElement('div');
    announcement.setAttribute('aria-live', 'polite');
    announcement.setAttribute('aria-atomic', 'true');
    announcement.className = 'sr-only';
    announcement.textContent = message;
    document.body.appendChild(announcement);
    setTimeout(() => {
        document.body.removeChild(announcement);
    }, 1000);
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
        initializeMobileNavigation();
        initializeToggleButton();
    });
} else {
    initializeMobileNavigation();
    initializeToggleButton();
}

window.resetMobileNavigation = function() {
    resetToRootLevel();
};

let resizeTimeout;

function debounceResize(callback, delay = 250) {
    if (resizeTimeout) {
        clearTimeout(resizeTimeout);
    }
    
    resizeTimeout = setTimeout(() => {
        if (isMobileMenuExpanded) {
            callback();
        }
        resizeTimeout = null;
    }, delay);
}

function handleResize() {
    debounceResize(closeMobileMenu);
}

window.onresize = handleResize;

window.toggleMobileMenu = toggleMobileMenu;
window.openMobileMenu = openMobileMenu;
window.closeMobileMenu = closeMobileMenu;